/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Vuex from 'vuex'
import firebase from '@/firebase'
import router from '@/router'
import tasks from '@/store/tasks.store'
import textlinks from '@/store/textlinks.store'
import categories from '@/store/categories.store'



Vue.use(Vuex)

export default new Vuex.Store({
   modules: {
    tasks,
    textlinks,
    categories,
  },
  state: {
    config:{
      isLoaded:false,
      suggestedLinks:[],
      defaultCategories:[],
    },
    authInitialized: false,
    user: {
      email:'',
      uid:'',
      setup:false,
      tema:'tema16',
      iconSize:61,
      iconCorners:2,
      columnCount:3,
      hasOpacity:false,
      transparency:0,
      textColor:'',
      bg:'',
      avatar:'',
      lastName:'',
      isAnonymous:true,
      lastLogin:null,
    },
    userDataFetched:false,
    anonymousRefUid:'',
    isAuthenticated: false,
    intendedUrl:'/',
    loading: 0,
    loadingMessage: '',
    users: [],
    userName:'',
    sharedCategoryId:'',
    sharedDashboardId:'',
  },
  mutations: {
    setUser(state, payload) {
      if(!state.user.uid && payload.uid){
        payload.lastLogin = Math.round(new Date().getTime()/1000);
      }
      state.user = payload;
    },
    setIsAuthenticated(state, payload) {
      state.isAuthenticated = payload;
    },
    setAuthInitialized(state, payload) {
      state.authInitialized = payload;
    },
    setIntendedUrl(state, payload) {
      state.intendedUrl = payload;
    },
    setUsersCache(state, users) {
      state.users = users
    },
    setConfig(state, config) {
      state.config = config
    },
    startLoading(state) {
      state.loading += 1;
    },
    stopLoading(state) {
      if(state.loading>0) state.loading -= 1;
    },
    setLoadingMessage(state, payload) {
      state.loadingMessage = payload;
    },
    setSharedCategoryId(state,payload){
      state.sharedCategoryId = payload;
    },
    setSharedDashboardId(state,payload){
      state.sharedDashboardId = payload;
    }
  },
  actions: {
    setIntendedUrl({commit},{url}){
      commit('setIntendedUrl',url)
    },
    startLoading({commit}){
      commit('startLoading')
    },
    stopLoading({commit}){
      commit('stopLoading')
      if(this.state.loading==0 && this.state.loadingMessage) {
        commit('setLoadingMessage','');
      }
    },
    setLoadingMessage({commit},{message}){
      commit('setLoadingMessage',message)
    },
    authInitialized({commit}, {initialized}){
      commit('setAuthInitialized',initialized);
    },
    saveConfig({commit},{config}){
      console.log('saveconfig')
      this.dispatch('startLoading');
      const db = firebase.firestore();
      db.collection('admin').doc('config').set(config).then(()=>{
        commit('setConfig', config);
        this.dispatch('stopLoading');
      })
    },

    getConfig({commit}){
      if(!this.state.config.isLoaded){
        this.dispatch('startLoading');
        const db = firebase.firestore();
        db.collection('admin').doc('config').get().then(doc => {
          var config = doc.data();
          config.isLoaded = true;
          commit('setConfig', config);
          this.dispatch('stopLoading');
        })
      }
    },

    authStateChanged({ commit }, {user}) {
      console.log('state authStateChanged',user);
      const db = firebase.firestore();
      this.dispatch('getConfig');

      if(user){

        this.dispatch('startLoading');
        db.collection('users').doc(user.uid).get().then(doc => {
          let dbUser = doc.data();
          if(dbUser){
            console.log('dados do usuario logado: ',dbUser)
            this.dispatch('stopLoading');
            commit('setUser', dbUser);
            commit('setIsAuthenticated', true);
            commit('setAuthInitialized',true);
            if(!dbUser.setup) {
              router.push({path:'/setup'});
              commit('setAuthInitialized',true);
              return;
            }
            if(!this.state.intendedUrl || this.state.intendedUrl=='/login' || this.state.intendedUrl=='/demo' || this.state.intendedUrl=='/'){
              this.state.intendedUrl = '/painel';
            }
            router.push({path:this.state.intendedUrl});
            commit('setAuthInitialized',true);
            return;
          } else {
            console.log('user db dont exists');
            //criar usuario

            let newUser = {
              email : user.email,
              uid : user.uid,
            }
            if(user.displayName) newUser.name = user.displayName;
            if(user.providerData  && user.providerData[0]){
              if(user.providerData[0].photoURL) newUser.avatar = user.providerData[0].photoURL;
              if(user.providerData[0].providerId) newUser.providerId = user.providerData[0].providerId;
              if(user.providerData[0].displayName) newUser.name = user.providerData[0].displayName
            }
            if(!newUser.name && this.state.userName){
              newUser.name = this.state.userName
            }

            if(user.isAnonymous){
              if(this.state.sharedDashboardId){
                this.dispatch('createFromDashboard',{user:newUser})
              } else {
                this.dispatch('createDemoUser',{user:newUser})
              }
            } else {
              if(this.state.anonymousRefUid){
                this.dispatch('createUserFromAnonymousUid',{user:newUser})
              } else {
                this.dispatch('createNewUser',{user:newUser})
              }
            }
          }
        }).catch((error)=>{
          console.log('erro ao consultar usuario: ',error);
          this.dispatch('stopLoading');
        });
      } else {
        console.log('user not authenticated');
        if(this.state.intendedUrl=='/demo' || this.state.sharedCategoryId || this.state.sharedDashboardId){
          console.log('auth.signInAnonymously');
          return firebase.auth().signInAnonymously()
        }
        if(!this.state.intendedUrl || this.state.intendedUrl=='/' || this.state.intendedUrl=='/painel'){
          this.state.intendedUrl = '/login';
        }
        console.log('router',router);
        router.push({path:this.state.intendedUrl});
        commit('setAuthInitialized',true);
      }
    },
    userSignOut({commit}) {
      firebase.auth().signOut();
      commit('setIsAuthenticated', false);
      this.dispatch('setIntendedUrl',{url:'/login'});
      router.push({path:'/login'});
      commit('setUser', {});
      this.state.userDataFetched = false;
      this.state.anonymousRefUid = null;
    },
    anonymousRedirectLogin({commit}) {
      console.log('anonymousRedirectLogin');
      this.state.anonymousRefUid = this.state.user.uid;
      commit('setIsAuthenticated', false);
      this.state.userDataFetched = false;
      router.push({path:'/login#registrar'});
    },
    createNewUser({ commit },{user}) {
      console.log('createnewuser');
      let userObject = {
        isAnonymous : false,
        name : user.name  || '',
        email : user.email  || '',
        uid : user.uid,
        setup: false,
        created_at: new Date().getTime(),
        tema:'tema16',
        iconSize:61,
        iconCorners:2,
        columnCount:3,
        hasOpacity:false,
        transparency:100,
        textColor:'',
        bg:'',
        avatar:'',
      };
      if(user.avatar) userObject.avatar = user.avatar;

      const db = firebase.firestore();
      const userDoc = db.collection('users').doc(user.uid);
      userDoc.set(userObject).then(()=>{
        commit('setUser',userObject);
        commit('setIsAuthenticated', true);
        this.dispatch('stopLoading');
        router.push({path:'/setup'});
        commit('setAuthInitialized',true);

        let batch = db.batch();

        let tasksRef = userDoc.collection('tasks')

        let taskRef1 = tasksRef.doc();
        batch.set(taskRef1, {index:1, name:"Tarefa 1", description:"(clique ao lado para editar)", theme:"ff4000"});
        let taskRef2 = tasksRef.doc();
        batch.set(taskRef2, {index:2, name:"Tarefa 2", description:"(clique ao lado para editar)", theme:"ff9933"});
        let taskRef3 = tasksRef.doc();
        batch.set(taskRef3, {index:3, name:"Tarefa 3", description:"(clique ao lado para editar)", theme:"ffff00"});
        let taskRef4 = tasksRef.doc();
        batch.set(taskRef4, {index:4, name:"Tarefa 4", description:"(clique ao lado para editar)", theme:"40ff00"});

        let textlinksRef = userDoc.collection('textlinks')
        let textlinkRef1 = textlinksRef.doc();
        batch.set(textlinkRef1, {index:1, name:"Link texto 1", url:"https://google.com"});
        let textlinkRef2 = textlinksRef.doc();
        batch.set(textlinkRef2, {index:2, name:"Link texto 2", url:"https://google.com"});

        batch.commit();


      }).catch((error)=>{
        console.log('error creating new user')
        console.log(error)
        this.dispatch('stopLoading');
      });
    },
    createUserFromAnonymousUid({ commit },{user}) {
      console.log('createUserFromAnonymousUid ',this.state.anonymousRefUid);
      let anonymousRefUid = this.state.anonymousRefUid;
      const db = firebase.firestore();
      let anonymousUserRef = db.collection('users').doc(anonymousRefUid);
      anonymousUserRef.get().then(doc => {
        let anonymousUser = doc.data();

        let userObject = {
          isAnonymous : false,
          anonymousRefUid : anonymousRefUid,
          name : user.name || '',
          email : user.email || '',
          uid : user.uid,
          setup: true,
          created_at: new Date().getTime(),
          tema:anonymousUser.tema,
          iconSize:anonymousUser.iconSize,
          iconCorners:anonymousUser.iconCorners,
          columnCount:anonymousUser.columnCount,
          hasOpacity:anonymousUser.hasOpacity,
          transparency:anonymousUser.transparency,
          textColor:anonymousUser.textColor,
          bg:anonymousUser.bg,
          avatar:anonymousUser.avatar,
        };

        const db = firebase.firestore();
        const newUserRef = db.collection('users').doc(user.uid);
        newUserRef.set(userObject).then(()=>{
          let newUserCategoriesRef = newUserRef.collection('categories');
          let q1 = anonymousUserRef.collection('categories').get().then(snapshot => {
            let batch = db.batch();
            snapshot.forEach(register => {
              let categoryRef = newUserCategoriesRef.doc(register.id);
              batch.set(categoryRef, register.data());
            });
            batch.commit();
          })

          let newUserLinksRef = newUserRef.collection('links');
          let q2 = anonymousUserRef.collection('links').get().then(snapshot => {
            let batch = db.batch();
            snapshot.forEach(register => {
              let linkRef = newUserLinksRef.doc(register.id);
              batch.set(linkRef, register.data());
            });
            batch.commit();
          })

          let newUserTasksRef = newUserRef.collection('tasks');
          let q3 = anonymousUserRef.collection('tasks').get().then(snapshot => {
            let batch = db.batch();
            snapshot.forEach(register => {
              let taskRef = newUserTasksRef.doc(register.id);
              batch.set(taskRef, register.data());
            });
            batch.commit();
          })

          let newUserTextlinksRef = newUserRef.collection('textlinks');
          let q4 = anonymousUserRef.collection('textlinks').get().then(snapshot => {
            let batch = db.batch();
            snapshot.forEach(register => {
              let textlinkRef = newUserTextlinksRef.doc(register.id);
              batch.set(textlinkRef, register.data());
            });
            batch.commit();
          })

          Promise.all([q1, q2, q3, q4]).then(()=>{
            console.log('all promises finished ');
            commit('setUser',userObject);
            commit('setIsAuthenticated', true);
            this.dispatch('stopLoading');
            router.push({path:'/painel'});
            commit('setAuthInitialized',true);
            this.state.anonymousRefUid = null;
          })

        }).catch((error)=>{
          console.log('error creating new user')
          console.log(error)
          this.dispatch('stopLoading');
        });
      });
    },
    createFromDashboard({ commit },{user}) {
      console.log('createFromDashboard');
      let uid = this.state.sharedDashboardId;
      this.dispatch('setSharedDashboardId',{id:''});
      const db = firebase.firestore();

      db.collection('shared_dashboards').doc(uid).get().then(doc=>{
        let profile = doc.data();
        let userObject = {
          isAnonymous : true,
          name : user.name || '',
          email : 'demo@urlinx.com.br',
          uid : user.uid,
          setup: true,
          created_at: new Date().getTime(),
          tema: profile.preferences.tema,
          iconSize: profile.preferences.iconSize,
          iconCorners: profile.preferences.iconCorners,
          columnCount: profile.preferences.columnCount,
          hasOpacity: profile.preferences.hasOpacity,
          transparency: profile.preferences.transparency,
          textColor: profile.preferences.textColor,
          bg: profile.preferences.bg,
          avatar:'',
        };
        const userDoc = db.collection('users').doc(user.uid);
        userDoc.set(userObject).then(()=>{

          let batch = db.batch();

          let i = 0;

          for(i in profile.categories){
            var category = profile.categories[i];
            let categoryRef = userDoc.collection('categories').doc(category.id);
            batch.set(categoryRef, category);
          }
          for(i in profile.links){
            var link = profile.links[i];
            let linkRef = userDoc.collection('links').doc(link.id);
            batch.set(linkRef, link);
          }

          let tasksRef = userDoc.collection('tasks')
          let taskRef1 = tasksRef.doc();
          batch.set(taskRef1, {index:1, name:"Tarefa 1", description:"(clique ao lado para editar)", theme:"ff4000"});
          let taskRef2 = tasksRef.doc();
          batch.set(taskRef2, {index:2, name:"Tarefa 2", description:"(clique ao lado para editar)", theme:"ff9933"});
          let taskRef3 = tasksRef.doc();
          batch.set(taskRef3, {index:3, name:"Tarefa 3", description:"(clique ao lado para editar)", theme:"ffff00"});
          let taskRef4 = tasksRef.doc();
          batch.set(taskRef4, {index:4, name:"Tarefa 4", description:"(clique ao lado para editar)", theme:"40ff00"});

          let textlinksRef = userDoc.collection('textlinks')
          let textlinkRef1 = textlinksRef.doc();
          batch.set(textlinkRef1, {index:1, name:"Link texto 1", url:"https://google.com"});
          let textlinkRef2 = textlinksRef.doc();
          batch.set(textlinkRef2, {index:2, name:"Link texto 2", url:"https://google.com"});


          batch.commit().then(()=>{
            commit('setUser',userObject);
            commit('setIsAuthenticated', true);
            this.dispatch('stopLoading');
            router.push({path:'/painel'});
            commit('setAuthInitialized',true);
          });

        }).catch((error)=>{
          console.log('error creating from shared dashboard')
          console.log(error)
          this.dispatch('stopLoading');
        });


      }).catch((error)=>{
        console.log('error creating from shared dashboard')
        console.log(error)
        this.dispatch('stopLoading');

      })
    },
    createDemoUser({ commit },{user}) {
      console.log('createDemoUser');
      let userObject = {
        isAnonymous : true,
        name : user.name  || '',
        email : 'demo@urlinx.com.br',
        uid : user.uid,
        setup: true,
        created_at: new Date().getTime(),
        tema:'tema16',
        iconSize:61,
        iconCorners:2,
        columnCount:3,
        hasOpacity:false,
        transparency:100,
        textColor:'',
        bg:'',
        avatar:'',
      };
      const db = firebase.firestore();
      const userDoc = db.collection('users').doc(user.uid);
      userDoc.set(userObject).then(()=>{
        commit('setUser',userObject);
        commit('setIsAuthenticated', true);
        this.dispatch('stopLoading');
        router.push({path:'/setup'});
        commit('setAuthInitialized',true);

        let batch = db.batch();

        let tasksRef = userDoc.collection('tasks')

        let taskRef1 = tasksRef.doc();
        batch.set(taskRef1, {index:1, name:"Tarefa 1", description:"(clique ao lado para editar)", theme:"ff4000"});
        let taskRef2 = tasksRef.doc();
        batch.set(taskRef2, {index:2, name:"Tarefa 2", description:"(clique ao lado para editar)", theme:"ff9933"});
        let taskRef3 = tasksRef.doc();
        batch.set(taskRef3, {index:3, name:"Tarefa 3", description:"(clique ao lado para editar)", theme:"ffff00"});
        let taskRef4 = tasksRef.doc();
        batch.set(taskRef4, {index:4, name:"Tarefa 4", description:"(clique ao lado para editar)", theme:"40ff00"});

        let textlinksRef = userDoc.collection('textlinks')
        let textlinkRef1 = textlinksRef.doc();
        batch.set(textlinkRef1, {index:1, name:"Link texto 1", url:"https://google.com"});
        let textlinkRef2 = textlinksRef.doc();
        batch.set(textlinkRef2, {index:2, name:"Link texto 2", url:"https://google.com"});

        batch.commit();

      }).catch((error)=>{
        console.log('error creating demo user')
        console.log(error)
        this.dispatch('stopLoading');
      });
    },
    redirectUser(){
      console.log('store redirectUser');
      var user = this.state.user;
      console.log('state redirect user',user)
      console.log('this.state.intendedUrl',this.state.intendedUrl)
      if(user){

      } else {
        if(!this.state.intendedUrl || this.state.intendedUrl=='/' || this.state.intendedUrl=='/painel'){
          this.state.intendedUrl = '/login';
        }
        router.push({path:this.state.intendedUrl});
      }

    },
    setUsersCache({commit}, {users}) {
      commit('setUsersCache', users);
    },

    setIconSize({commit},{size}){
      let user = this.state.user;
      user.iconSize=size;
      commit('setUser',user);

      const db = firebase.firestore();
      const userDoc = db.collection('users').doc(this.state.user.uid);
      userDoc.update({iconSize:size});
    },
    setIconCorners({commit},{type}){
      let user = this.state.user;
      user.iconCorners=type;
      commit('setUser',user);

      const db = firebase.firestore();
      const userDoc = db.collection('users').doc(this.state.user.uid);
      userDoc.update({iconCorners:type});
    },
    setTransparency({commit},{transparency}){
      let user = this.state.user;
      user.transparency=transparency;
      commit('setUser',user);

      const db = firebase.firestore();
      const userDoc = db.collection('users').doc(this.state.user.uid);
      userDoc.update({transparency:transparency});
    },
    setTextColor({commit},{textColor}){
      console.log('store setTextColor',textColor)
      let user = this.state.user;
      user.textColor=textColor;
      commit('setUser',user);

      const db = firebase.firestore();
      const userDoc = db.collection('users').doc(this.state.user.uid);
      userDoc.update({textColor:textColor});
    },
    setBg({commit},{image}){
      let user = this.state.user;
      user.bg=image;
      commit('setUser',user);

      const db = firebase.firestore();
      const userDoc = db.collection('users').doc(this.state.user.uid);
      userDoc.update({bg:image});
    },

    setAvatar({commit},{image}){
      console.log('store setavatar');
      let user = this.state.user;
      user.avatar=image;
      commit('setUser',user);

      const db = firebase.firestore();
      const userDoc = db.collection('users').doc(this.state.user.uid);
      userDoc.update({avatar:image});
    },


    updateUserProfile({commit},obj){

      console.log('store updateuserprofle obj',obj);
      let user = this.state.user;
      var field; 
      for(field in obj){
        user[field]=obj[field];
      }
      console.log('obj',obj);
      commit('setUser',user);

      const db = firebase.firestore();
      const userDoc = db.collection('users').doc(this.state.user.uid);
      userDoc.update(obj);
    },
    

    setColumnCount({commit},{columnCount}){
      let user = this.state.user;
      user.columnCount=columnCount;
      commit('setUser',user);

      const db = firebase.firestore();
      const userDoc = db.collection('users').doc(this.state.user.uid);
      userDoc.update({columnCount:columnCount});

      var categories = this.getters.orderedCategories;

      var column = 1;
      var index = 1;
      categories.forEach(cat=>{
        cat.column = column++;
        cat.index = index;
        if(column>columnCount){
          column = 1;
          index++;
        }
      });
      commit('setCategories',categories);

      this.dispatch('reorderCategories')

    },
    reloadUser({commit},{user}){
      console.log('reloadUser',user);
      commit('setUser',user);
      bodyTheme(user.tema);
    },
    setTheme({commit},{theme}){
      let user = this.state.user;
      user.tema=theme;
      commit('setUser',user);

      const db = firebase.firestore();
      const userDoc = db.collection('users').doc(this.state.user.uid);
      userDoc.update({tema:theme});
    },
    setSharedCategoryId({commit},{id}){
      commit('setSharedCategoryId',id);
    },
    setSharedDashboardId({commit},{id}){
      commit('setSharedDashboardId',id);
    },

    getUsers({commit}){
      const db = firebase.firestore();
      const usersRef = db.collection('users').onSnapshot(querySnapshot => {
        let users = [];
        querySnapshot.forEach(doc => {
          users.push({ id:doc.id, ...doc.data() });
        });
        commit('setUsersCache', users);
      });
    },
  },
  getters:{
    user: state => {
      if(state.isAuthenticated && state.user){
        return state.user
      }
      return {};
    },

    preferenceTema: (state) =>{
      var defaultValue = 'tema16';
      if(!state.isAuthenticated || !state.user) return defaultValue;
      return state.user.tema ||  defaultValue;
    },
    preferenceIconSize: (state) =>{
      let defaultValue =  61;
      if(!state.isAuthenticated || !state.user) return defaultValue;
      return state.user.iconSize || defaultValue;
    },
    preferenceIconCorners: (state) =>{
      let defaultValue =  2;
      if(!state.isAuthenticated || !state.user) return defaultValue;
      return state.user.iconCorners || defaultValue;
    },
    preferenceColumnCount: (state,getters) =>{
      if(getters.isMobile) return 1;
      let defaultValue =  3;
      if(!state.isAuthenticated || !state.user) return defaultValue;
      return state.user.columnCount || defaultValue;
    },
    preferenceTransparency: (state) =>{
      let defaultValue =  0;
      if(!state.isAuthenticated || !state.user) return defaultValue;
      return state.user.transparency || defaultValue;
    },
    preferenceTextColor: (state) =>{
      let defaultValue =  '';
      if(!state.isAuthenticated || !state.user) return defaultValue;
      return state.user.textColor || defaultValue;
    },
    preferenceHasOpacity: (state) =>{
      let defaultValue =  false;
      if(!state.isAuthenticated || !state.user) return defaultValue;
      return state.user.hasOpacity || defaultValue;
    },
    preferenceBg: (state) =>{
      let defaultValue =  '';
      if(!state.isAuthenticated || !state.user) return defaultValue;
      return state.user.bg || defaultValue;
    },
    preferenceAvatar: (state) =>{
      let defaultValue =  '';
      if(!state.isAuthenticated || !state.user) return defaultValue;
      return state.user.avatar || defaultValue;
    },

    preferences: (state,getters) => {
      let defaults = {
        tema:'tema13',
        iconSize:61,
        iconCorners:2,
        columnCount:3,
        hasOpacity:false,
        transparency:0,
        textColor:'',
        bg:'',
        avatar:'',
      }
      if(!state.isAuthenticated || !state.user) return defaults;
      let obj = state.user;
      if(!obj.tema) obj.tema = defaults.tema;
      if(!obj.iconSize) obj.iconSize = defaults.iconSize;
      if(!obj.iconCorners) obj.iconCorners = defaults.iconCorners;
      if(!obj.columnCount) obj.columnCount = defaults.columnCount;
      if(!obj.hasOpacity) obj.hasOpacity = defaults.hasOpacity;
      if(!obj.transparency) obj.transparency = defaults.transparency;
      if(!obj.textColor) obj.textColor = defaults.textColor;
      if(!obj.bg) obj.bg = defaults.bg;
      if(!obj.avatar) obj.avatar = defaults.avatar;
      if(getters.isMobile) obj.columnCount = 1;
      return obj;
    },
    config: state => {
      return state.config;
    },
    userId: state => {
      if(state.isAuthenticated && state.user && state.user.uid){
        return state.user.uid
      }
      return null;
    },
    getUsersById: state => (ids) => {
      return state.users.filter(user => ids.indexOf(user.id) >= 0);
    },

    isMobile: state=> {
      return !!window.navigator.userAgent.match(/Android|iPhone|iPad/i);
    },
    isChrome: state=> {
      return !!window.navigator.userAgent.match(/Chrome/i);
    }

  }
})
